import { render, staticRenderFns } from "./ads-filter.vue?vue&type=template&id=5b1713a8&scoped=true"
import script from "./ads-filter.vue?vue&type=script&lang=ts"
export * from "./ads-filter.vue?vue&type=script&lang=ts"
import style0 from "./ads-filter.vue?vue&type=style&index=0&id=5b1713a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1713a8",
  null
  
)

export default component.exports